import { useFetchMxfNestApi } from "hooks";

export const useRelIbscbsCat = () => {
  const count = id =>
    useFetchMxfNestApi(id ? `/rel-ibscbs-cat/count/${id}` : null);

  const listCategories = (id, params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return useFetchMxfNestApi(
      id ? `/rel-ibscbs-cat/ibs-class/${id}/categories?${queryParams}` : null,
    );
  };

  return { count, listCategories };
};
